import { InferType, object, string } from "yup";

export type Address = InferType<typeof AddressSchema>;

export const AddressSchema = object({
    streetAddress: string().optional(),
    locality: string().optional(),
    postalCode: string().optional(),
    region: string().optional(),
    country: string().optional(),
});
